/**
 * Presentation-time brand normalizer.
 *
 * Vervangt legacy "NEXORA" / "Nexora" / "nexora" strings in gecachte content
 * (advies-tekst, LLM-uitkomsten en technische data-attributies uit de DB)
 * door de nieuwe merknaam "JustEasySEO" op RENDER-tijd. DB-inhoud blijft
 * ongewijzigd.
 *
 * Substring-based (case-insensitive) omdat oude records ook technische
 * tokens bevatten zoals "eigennexorascore" die door legacy LLM-cache in de
 * bron-lijst terechtkwamen. Deze worden zo omgezet naar "eigenJustEasySEOscore".
 */
export function normalizeBrand(text) {
  if (text == null) return text;
  return String(text).replace(/nexora/gi, (match) => {
    // Preserve casing style waar mogelijk: NEXORA → JustEasySEO (uppercase intent),
    // Nexora/nexora → JustEasySEO. In alle gevallen: één label.
    return "JustEasySEO";
  });
}

export default normalizeBrand;
